import { Box, CircularProgress } from '@mui/material';
import QuestionCard from '../components/QuestionCard';
import { QuizNotification } from '../components/QuizNotification';
import { QuestionCardStyles } from '../styles/QuestionCardStyles';
import { CommonStyles } from '../styles/CommonStyles';
import { useQuizNotification } from '../hooks/useQuizNotification';
import { QuizHeader, QuizNavigation } from '../components/quiz';
import { useFinalExam } from '../hooks/useFinalExam';
import FinalExamCompletionModal from '../components/finalExam/FinalExamCompletionModal';
import FinalExamCompletionButton from '../components/FinalExamCompletionButton';

const FinalExam = () => {
  const { showNotification, hideNotification } = useQuizNotification();
  const {
    // State
    currIndex,
    isCompleteModalOpen,
    loading,

    // Data
    userQuestions,

    // Computed values
    isCurrentQuestionBookmarked,
    isCurrentQuestionAnswered,
    score,
    totalQuestions,
    isCompleted,
    isAllQuestionsCompleted,

    // Event handlers
    handleBookmarkToggle,
    handleNavigateToDashboard,
    handleCloseCompleteModal,
    handleCompleteFinalExam,
    handleQuestionSelection,
    handlePreviousQuestion,
    handleNextQuestion,
    handleNavigateToHistory,
  } = useFinalExam();

  if (loading) {
    return (
      <Box sx={CommonStyles.loadingContainer}>
        <CircularProgress size={70} />
      </Box>
    );
  }

  if (!userQuestions?.length) {
    return <Box sx={{ textAlign: 'center', py: 4 }}>No questions found</Box>;
  }

  return (
    <Box sx={{ ...QuestionCardStyles.root }}>
      {showNotification && (
        <QuizNotification
          onClose={() => hideNotification(false)}
          onDontShowAgain={hideNotification}
        />
      )}
      <Box sx={{ ...QuestionCardStyles.container, position: 'relative' }}>
        <QuizHeader
          isBookmarked={isCurrentQuestionBookmarked}
          onBookmarkToggle={handleBookmarkToggle}
          isCompleted={isCompleted}
          isFinalExam={true}
        />

        <FinalExamCompletionButton
          isVisible={!isCompleted}
          onComplete={handleCompleteFinalExam}
        />

        <QuestionCard
          key={userQuestions[currIndex].question.id}
          userQuestion={userQuestions[currIndex]}
          index={currIndex}
          onSelectedOption={handleQuestionSelection}
          disabled={isCompleted}
        />

        <QuizNavigation
          currentIndex={currIndex}
          totalQuestions={totalQuestions}
          onPrevious={handlePreviousQuestion}
          onNext={handleNextQuestion}
          isCurrentQuestionAnswered={isCurrentQuestionAnswered}
          isAllQuestionsCompleted={false} // Always false for final exam navigation
        />

        <FinalExamCompletionModal
          open={isCompleteModalOpen}
          onClose={handleCloseCompleteModal}
          score={score}
          totalQuestions={totalQuestions}
          onNavigateToDashboard={handleNavigateToDashboard}
          onNavigateToHistory={handleNavigateToHistory}
        />
      </Box>
    </Box>
  );
};

export default FinalExam;
